import { useEffect, useState } from "react";
import { useDeviceUsersCountQuery } from "generated/graphql";

export const useDeviceUserCount = (
  tenantId: string
): { deviceUserCount: number | null; fetching: boolean } => {
  const [deviceUserCount, setDeviceUserCount] = useState<number | null>(null);

  const { data, fetching } = useDeviceUsersCountQuery({
    variables: {
      params: {
        grants: [
          {
            resourceId: tenantId,
            roles: ["device_user"]
          }
        ],
        sortBy: "name"
      },
      first: 1
    },
    requestPolicy: "network-only"
  });

  useEffect(() => {
    const count = data?.deviceUsersResult?.count ?? null;
    if (data) {
      setDeviceUserCount(count);
    }
  }, [tenantId, data]);

  return { deviceUserCount, fetching };
};
